import Plot from "react-plotly.js";
import PropTypes from 'prop-types';

const TimeSeries = ({ data, range, title, width, height }) => {

  return (
    <>
      <Plot
        style={{ display: "flex", justifyContent: "center" }}
        data={data[0]}
        layout={{
          title: title,
          width: width,
          height: height,
          // Adjust margin to move the heatmap to the top
          margin: {
            t: 25, // Adjust this value as needed
            l: 25,
            r: 25,
            b: 25
          },
          xaxis: {
            range: range,
            type: 'date',
            automargin: true,
          },
          yaxis: {
            autorange: true,
            type: 'linear',
            automargin: true,
          },
          autosize: true, // Automatically adjust the size of the plot
        }}
      />
    </>

  );
};


TimeSeries.propTypes = {
    data: PropTypes.any,
    range: PropTypes.any,
    title: PropTypes.any,
    width: PropTypes.any,
    height: PropTypes.any,
  };
export default TimeSeries;